import script from "./Transfer.vue?vue&type=script&setup=true&lang=js"
export * from "./Transfer.vue?vue&type=script&setup=true&lang=js"

import "./Transfer.vue?vue&type=style&index=0&id=febab942&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-febab942"]])

export default __exports__